import React from 'react';
import Logger from '../../util/Logger';
import Response from '../../models/Response';
import './ResponseCard.css';
import $ from 'jquery';
import { arrowDownwardIcon, arrowUpwardIcon } from '../../constants';
import Media from '../../models/Media';
import { NavigationUtils } from '../../util/NavigationUtils';

export class ResponseCard extends React.Component {

  constructor (props) {
    super(props);

    if (!props.response) {
      Logger.assert('Must construct ResponseCard with a Response object');
    }
  }

  handleOnItemClicked = ($event, response) => {
    $event.preventDefault();

    const { onItemClicked } = this.props;
    if (!!onItemClicked) {
      onItemClicked(response);
    }
  };

  getContentSection = (response, responseClassName, onClick) => {
    const pdf = Response.getPdfAttachment(response);

    const onClickPdf = ($event, pdf) => {
      $event.preventDefault();

      if (!!pdf) {
        const url = Media.getPdfUrl(pdf);
        if (!!url) {
          NavigationUtils.openTab(url);
        }
      }
    };

    const photo = Response.getPhotoAttachment(response);
    const originalPhotoUrl = photo ? Media.getPhotoUrl(photo) : '';
    const photoUrl = photo ? Media.getPhotoUrl(photo, null, 300) : '';
    return (
      <div className="row no-gutters">
        <div className="col">
          { !!pdf && (
            <div
              className="row no-gutters d-inline-block clickable"
              onClick={ $e => onClickPdf($e, pdf) }>
              <i className="material-icons mr-3">attachment</i>
              1 Attachment
            </div>
          ) }

          <div
            className={ `row no-gutters  ${responseClassName}` }
            onClick={ $event => !!onClick ? onClick($event) : null }>
            { Response.getContent(response) }
          </div>

          { !!photo && (
            // If the card has a photo, allocate space for it - so that when it loads the page won't flicker
            <div
              style={ { minHeight: 300 } }
              className="row no-gutters"
              onClick={ $event => !!onClick ? onClick($event) : null }>
              <img
                src={ photoUrl }
                alt="Post Media Content"
                onClick={ () => NavigationUtils.openTab(originalPhotoUrl) } />
            </div>
          ) }
        </div>
      </div>
    );
  };

  getCountsSection = (response, showComments, showLikes) => {
    const { votingMode } = this.props;
    return (
      <div className={ `${ votingMode === 'star-rating' ? 'col-2' : 'col-3' } response-counts h-100` }>
        <div className="row h-100 no-gutters">
          { (votingMode === 'star-rating') ?
            <>
              { !showLikes &&
              <div className={`response-ratings ${ showComments ? 'col-6' : 'col-4' }`}>
                { Response.getAvgRating(response).toFixed(1) }
              </div>
              }
              { showLikes &&
              <>
                <div className="col-4"/>
                <div className="response-likes col-4">
                  { Response.getLikes(response) }
                </div>
                <div className="response-dislikes col-4">
                  { Response.getDislikes(response) }
                </div>
              </>
              }
            </>
            :
            <>
              { !showComments &&
              <div className="col-4" />
              }
              <div className="response-likes col-4">
                { Response.getLikes(response) }
              </div>
              <div className="response-dislikes col-4">
                { Response.getDislikes(response) }
              </div>
            </>
          }
          { showComments && 
          <div className={ `response-children ${votingMode === 'star-rating' ? 'col-6' : 'col-4'}` }>
            { Response.getChildrenCount(response) }
          </div>
          }
        </div>
      </div>
    );
  };

  isNoteworthyResponse = (response) => {
    const { noteworthy } = this.props;
    if (!noteworthy || noteworthy.length === 0) {
      return false;
    } else {
      let index = -1;
      for (let i = 0; i < noteworthy.length; ++i) {
        const item = noteworthy[i];
        if (Response.getId(item) === Response.getId(response)) {
          index = i;
          break;
        }
      }
      return index >= 0;
    }
  };

  getContentForChildResponse = (response) => {
    // Noteworthy only passed on noteworthy picker screen
    const { noteworthy, onItemClicked, votingMode } = this.props;
    return (
      <li
        id={ Response.getId(response) }
        className={ `row response-card no-gutters d-flex h-100 page-break-avoid ${!!onItemClicked &&
        'clickable'}
        ${!!this.isNoteworthyResponse(response) ? 'response-marked-noteworthy' : ''}` }>
        <div className={ `${votingMode === 'star-rating' ? 'col-10' : 'col-9'} response-content h-100` }>
          <AuthorSection response={ response } child={ true } />
          { this.getContentSection(response, `response-child
          ${!!noteworthy ? 'response-child-noteworthy-picker' : ''}`,
            $event => this.handleOnItemClicked($event, response))
          }
        </div>
        { this.getCountsSection(response, false, true) }
      </li>
    );
  };

  getContentForTopLevelResponse = (response) => {
    const { onItemClicked, votingMode } = this.props;
    return (
      <li
        id={ Response.getId(response) }
        className={ `row response-card no-gutters d-flex h-100 page-break-avoid ${!!onItemClicked &&
        'clickable'}
        ${!!this.isNoteworthyResponse(response) ? 'response-marked-noteworthy' : ''}` }>
        <div className={ `${votingMode === 'star-rating' ? 'col-10' : 'col-9'} response-content h-100` }>
          <AuthorSection response={ response } />
          { this.getContentSection(response, `response-top-level`,
            $event => this.handleOnItemClicked($event, response))
          }
        </div>
        { this.getCountsSection(response, false, false) }
      </li>
    );
  };

  scrollToResponse = (scrollingOffset, response) => {

    // Scroll to the element if it is visible
    const element = $(`#${Response.getId(response)}`);
    const offset = element.offset();

    // Offset is not defined if the DOM has not been rendered
    if (offset) {
      offset.top -= scrollingOffset;

      $('html, body').animate({
        scrollTop: offset.top
      }, null, null, () => {
        // Add Pulse/Highlight Animation
        element.addClass('add-pulse');

        // Remove Pulse/Highlight Animation
        // - animation can be added again
        setTimeout(function () {
          element.removeClass('add-pulse');
        }, 1500);
      });

    }

    // Works but content is covered by the ribbons at the end
    // const domElement = element[0];
    // if (domElement) {
    //   domElement.scrollIntoView({
    //     block: 'start',
    //     behavior: 'smooth'
    //   });
    // }
  };

  getContentForNoteworthyResponse = (
    response, scrollingOffset, editing, sections, onSectionsSet, index, isAllResponsesEnabled) => {
    const onClickNoteworthyResponse = ($event) => {
      $event.preventDefault();

      this.handleOnItemClicked($event, response);
      this.scrollToResponse(scrollingOffset, response);
    };

    return (
      <li
        id={ `NOTEWORTHY-${Response.getId(response)}` }
        className="row response-card no-gutters d-flex h-100 page-break-avoid">
        <div className="col response-content h-100">
          <div className="card-divider noteworthy" />
          <div className="row no-gutters">
            <div className="col-11">
              { this.getContentSection(response,
                `response-noteworthy d-inline-block ${isAllResponsesEnabled
                  ? 'clickable response-noteworthy-hover'
                  : '' }`,
                onClickNoteworthyResponse) }
            </div>
            <div className="col-1">
              <EditArrowSection
                sections={ sections }
                onSectionsSet={ onSectionsSet }
                editing={ editing }
                index={ index } />
            </div>
          </div>
        </div>
      </li>
    );
  };

  getContentForTopRankResponse = (response, rank, scrollingOffset, isAllResponsesEnabled) => {
    const onClickTopRankResponse = ($event) => {
      $event.preventDefault();

      this.handleOnItemClicked($event, response);
      this.scrollToResponse(scrollingOffset, response);
    };

    const { votingMode } = this.props;

    return (
      <li
        id={ `TOP-${Response.getId(response)}` }
        className="row response-card no-gutters d-flex h-100 page-break-avoid">
        <div className="col">

          { /* Card Divider*/ }
          <div className="row no-gutters">
            <div className="col-9">
              <div className="row no-gutters">
                <div className="col-lg-1 col-2" />
                <div className="col-lg-11 col-10 card-divider" />
              </div>
            </div>
            <div className="col-3 card-divider">
            </div>
          </div>

          <div className="row no-gutters">
            <div className={ `${votingMode === 'star-rating' ? 'col-10' : 'col-9'} response-content h-100` }>
              <div className="row no-gutters">
                <div className="col-lg-1 col-2">
                  <div className="response-rank-circle my-auto d-flex">
                    <div className="h-100 m-auto inner-text font-weight-semibold">
                      { rank }
                    </div>
                  </div>
                </div>
                <div className="col-lg-11 col-10">
                  <AuthorSection response={ response } />
                  { this.getContentSection(response, `response-top-rank ${isAllResponsesEnabled
                    ? 'clickable response-top-rank-hover'
                    : '' }`,
                    onClickTopRankResponse) }
                </div>
              </div>
            </div>
            { this.getCountsSection(response, true) }
          </div>
        </div>
      </li>
    );
  };

  render () {
    const { response, isChild, isNoteworthy, rank, scrollingOffset, editing, sections, onSectionsSet, index, isAllResponsesEnabled } = this.props;
    let responseContent;
    if (isNoteworthy) {
      responseContent = this.getContentForNoteworthyResponse(response, scrollingOffset, editing,
        sections, onSectionsSet, index, isAllResponsesEnabled);
    } else if (!!rank) {
      responseContent = this.getContentForTopRankResponse(response, rank, scrollingOffset,
        isAllResponsesEnabled);
    } else if (isChild) {
      responseContent = this.getContentForChildResponse(response);
    } else {
      responseContent = this.getContentForTopLevelResponse(response);
    }
    return responseContent;
  }
}

const AuthorSection = ({ response, child }) => {
  return (
    <div className="row no-gutters author-info">
      <div
        className={ `${!!child
          ? 'child-card'
          : 'toplevel-card'} ${Response.isHeroCreated(response)
          ? 'is-creator'
          : 'is-not-creator'}` }>
        { Response.getAuthorName(response) }
      </div>
    </div>
  );
};

const EditArrowSection = ({ sections, onSectionsSet, editing, index }) => {
  if (!editing) {
    return null;
  }

  const upDisabled = index === 0;
  const downDisabled = index >= sections.length - 1;

  const onUpClicked = ($event) => {
    $event.preventDefault();

    if (!upDisabled) {
      const newSections = [];
      for (let section of sections) {
        newSections.push(section);
      }

      const currentSection = newSections[index];
      newSections[index] = newSections[index - 1];
      newSections[index - 1] = currentSection;
      Logger.info(`Move section ${currentSection.name} from ${index} to ${index - 1}`);
      onSectionsSet(newSections);
    }
  };

  const onDownClicked = ($event) => {
    $event.preventDefault();

    if (!downDisabled) {
      const newSections = [];
      for (let section of sections) {
        newSections.push(section);
      }

      const currentSection = newSections[index];
      newSections[index] = newSections[index + 1];
      newSections[index + 1] = currentSection;
      Logger.info(`Move section ${currentSection.name} from ${index} to ${index + 1}`);
      onSectionsSet(newSections);
    }
  };

  return (
    <div className="col-1 switcher-arrows">
      <div className={ `${upDisabled ? 'invisible' : 'clickable'}` } onClick={ onUpClicked }>
        <i className="material-icons">{ arrowUpwardIcon }</i>
      </div>
      <div className={ `${downDisabled ? 'invisible' : 'clickable'}` } onClick={ onDownClicked }>
        <i className="material-icons">{ arrowDownwardIcon }</i>
      </div>
    </div>
  );
};
